module.exports = __webpack_public_path__ + "img/H5-02.d7de7113.png";